












































import {Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatPrice} from "@/utils/formatters";
import {State} from "vuex-class";

@Component({})
export default class MinMaxStock extends mixins(ComponentBaseMixin) {
  columns = [
    {field: 'storeName', title: 'Naziv objekta'},
    {field: 'address', title: 'Adresa'},
    {field: 'city', title: 'Mesto'},
    {field: 'productName', title: 'Artikal'},
    {field: 'minStock', title: 'Min. zaliha', formatter: formatPrice, align: 'right', width: 80},
    {field: 'stock', title: 'Zaliha', formatter: formatPrice, align: 'right', width: 80},
    {field: 'maxStock', title: 'Max. zaliha', formatter: formatPrice, align: 'right', width: 80},
  ];
  data = [];
  tableOptions = {
    pagination: true,
    pageSize: 500,
    search: true,
    showExport: true,
    exportTypes: ['excel']
  }
  isBusySearch = false;

  selectedProduct = null;
  products = [];

  @State user;

  async created() {
    const { data } = await this.$http.get('/api/GetAllProducts');
    this.products = data;
  }

  mounted() {
    $("#select2").select2({
      placeholder: "-",
      width: "100%",
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        url: "/api/SearchStoresByName",
        data: function(term) {
          return { name: term.term || "" };
        },
        headers: {'X-User': this.user.id},
        processResults: function(data) {
          return {
            results: data.map(function(store) {
              return {
                id: store.id,
                text: `${store.name} (${store.city})`,
              };
            }),
          };
        },
      },
    });
  }

  async load() {
    if (this.isBusySearch) return;
    this.isBusySearch = true;
    $((<any>this.$refs).table.$el).bootstrapTable('showLoading');
    try {
      let selectedStore = $("#select2").select2("val");
      const { data } = await this.$http.get('/api/GetMinMaxStock', {params: {store: selectedStore, product: this.selectedProduct}});
      this.data = data;
    } catch (e) {
      this.showError('neuspesnoUcitavanjePodataka');
    } finally {
      $((<any>this.$refs).table.$el).bootstrapTable('hideLoading');
      this.isBusySearch = false;
    }

  }
}
